import { JSX } from 'react'
import { trackingService } from '@services'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const RouteTracker = (): JSX.Element => {
  const location = useLocation()
  useEffect(() => {
    trackingService.trackPage(location.pathname)
  }, [location])

  return null
}
